import React, { useEffect, useState } from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import OrganizationTable from '../components/OrganizationTable';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../api/auth/authSlice';

const OrganizationsPage = () => {
  let navigate = useNavigate();
  const user = useSelector(selectUser);
  const organizations = useSelector((state) => state.organizations.organizations);
  const [orgCount, setOrgCount] = useState(0);
  const isPartner = user?.role === 'partner';
  const isLimitReached = isPartner && orgCount >= user.organization_limit;

  useEffect(() => {
    if (isPartner) {
      const count = organizations.filter((org) => org.partner_id === user._id).length;
      setOrgCount(count);
    }
  }, [isPartner, organizations, user]);

  return (
    <Box p={2}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <h1>Organizations</h1>
        {user.role === 'admin' && (
          <Box>
            <Tooltip title={isLimitReached ? 'Organization Limit Reached' : ''} arrow>
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate('/organizations/create')}
                  disabled={isLimitReached}
                >
                  Create Organization
                </Button>
              </span>
            </Tooltip>
          </Box>
        )}
      </Box>
      <OrganizationTable />
    </Box>
  );
};

export default OrganizationsPage;
